import { html, View } from 'rune-ts';
import { HeartActiveIcon, HeartLineIcon } from '@services/MarppleShop/shared/components/atoms/Icon';
import klass from './LikeButtonView.module.scss';
import { classes } from '@services/MarppleShop/shared/util';
import { font } from '@services/MarppleShop/shared/typography';
import { humanReadableNumberV2 } from '../../../../../../shared/utils/formatter';

export type TLikeButtonViewProps =
  | {
      device: 'MO';
      state: 'Click';
      theme: 'Dark';
      count: number;
      onClick: (event: MouseEvent) => void;
    }
  | {
      device: 'MO';
      state: 'Click';
      theme: 'Light';
      count: number;
      onClick: (event: MouseEvent) => void;
    }
  | {
      device: 'MO';
      state: 'Unclick';
      theme: 'Dark';
      count: number;
      onClick: (event: MouseEvent) => void;
    }
  | {
      device: 'MO';
      state: 'Unclick';
      theme: 'Light';
      count: number;
      onClick: (event: MouseEvent) => void;
    }
  | {
      device: 'PC';
      state: 'Unclick';
      theme: 'Light';
      count: number;
      onClick: (event: MouseEvent) => void;
    }
  | {
      device: 'PC';
      state: 'Click';
      theme: 'Light';
      count: number;
      onClick: (event: MouseEvent) => void;
    }
  | {
      device: 'PC';
      state: 'Unclick';
      theme: 'Dark';
      count: number;
      onClick: (event: MouseEvent) => void;
    }
  | {
      device: 'PC';
      state: 'Click';
      theme: 'Dark';
      count: number;
      onClick: (event: MouseEvent) => void;
    };

export class LikeButtonView extends View<TLikeButtonViewProps> {
  protected override onRender() {
    this.addEventListener('click', this.data.onClick);
  }

  setState(state: TLikeButtonViewProps['state']) {
    this.data.state = state;
    this.redraw();
  }

  setCount(count: TLikeButtonViewProps['count']) {
    this.data.count = count;
    this.redraw();
  }

  protected override template({ device, theme, state, count }: TLikeButtonViewProps) {
    const { value, unit } = humanReadableNumberV2.to(count, ET.lang == 'kr');

    return html`<button
      class="${classes({
        [klass.pc]: device === 'PC',
        [klass.mo]: device === 'MO',
        [klass.dark]: theme === 'Dark',
        [klass.light_unclick]: theme === 'Light' && state === 'Unclick',
        [klass.light_click]: theme === 'Light' && state === 'Click',
      })}"
      type="button"
    >
      ${state === 'Click' ? HeartActiveIcon : HeartLineIcon}

      <span class="${font(device === 'PC' ? '14_medium2' : '12_medium2')}">${value + unit}</span>
    </button>`;
  }
}
